'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Button from './Button';
interface AlertModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  onConfirm: () => void;
  onClose?: () => void;
}
const AlertModal: React.FC<AlertModalProps> = t0 => {
  const $ = _c(18);
  const {
    isOpen,
    title,
    message,
    confirmLabel: t1,
    onConfirm,
    onClose
  } = t0;
  const confirmLabel = t1 === undefined ? "Continue" : t1;
  if (!isOpen) {
    return null;
  }
  let t2;
  if ($[0] !== onClose) {
    t2 = <div className="absolute inset-0 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" onClick={onClose} />;
    $[0] = onClose;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="absolute -top-24 -right-24 w-48 h-48 bg-primary/10 rounded-full blur-3xl pointer-events-none" />;
    t4 = <div className="absolute -bottom-24 -left-24 w-48 h-48 bg-primary/5 rounded-full blur-3xl pointer-events-none" />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] !== title) {
    t5 = <h3 className="text-xl font-bold text-white mb-3">{title}</h3>;
    $[4] = title;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== message) {
    t6 = <p className="text-secondary-grey text-base leading-relaxed mb-8">{message}</p>;
    $[6] = message;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== confirmLabel || $[9] !== onConfirm) {
    t7 = <Button onClick={onConfirm} className="w-full h-12 text-base font-semibold">{confirmLabel}</Button>;
    $[8] = confirmLabel;
    $[9] = onConfirm;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t5 || $[12] !== t6 || $[13] !== t7) {
    t8 = <div className="relative w-full max-w-sm bg-tertiary-grey/10 border border-white/10 backdrop-blur-xl rounded-2xl p-6 shadow-2xl animate-in zoom-in-95 duration-300 overflow-hidden">{t3}{t4}<div className="relative">{t5}{t6}{t7}</div></div>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t2 || $[16] !== t8) {
    t9 = <div className="fixed inset-0 z-100 flex items-center justify-center p-4">{t2}{t8}</div>;
    $[15] = t2;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
};
export default AlertModal;